
const table = {
    datatable: {
        root: 'bg-gray-100 rounded-lg overflow-hidden text-base',
        table: 'min-w-full ',

        thead: 'h-[55px]',
        headerrow: 'bg-gray-200',
        headercell:
            'relative px-4 py-3 bg-white text-left text-xs font-medium text-gray-600 uppercase tracking-wider select-none cursor-pointer',

        bodyrow: 'odd:bg-gray-100 even:bg-white hover:bg-brand-green transition-colors h-[35px]',
        bodycell: 'px-4 py-3 text-gray-700 whitespace-nowrap',

        rowgroupheader: 'bg-gray-100 text-gray-800',
        footerrow: 'bg-gray-50 text-gray-600',
        footercell: 'px-4 py-2',
    },

    column: {
        headercell: '', // Optional overrides
        bodycell: 'text-center',
    },
}

export default table
